import cn from 'classnames'
import { Checkbox, Text } from '@radix-ui/themes'

interface ClientPhotoCheckboxProps {
  checked: boolean
  disabled: boolean
  onChange: (checked: boolean) => void
  className?: string
}

export const ClientPhotoCheckbox = ({ checked, disabled, onChange, className }: ClientPhotoCheckboxProps) => (
  <Text as="label" size="2" className={cn('flex items-center gap-2', className)}>
    <Checkbox checked={checked} disabled={disabled} onCheckedChange={(next) => onChange(next === true)} />
    Client sends the meter photo
  </Text>
)
